import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Homepage from './components/Homepage';
import ScrollToTop from './components/ScrollToTop';
import ExitIntentPopup from './components/ExitIntentPopup'; 

// Main Pages
import Services from './pages/Services';
import Products from './pages/Products';
import Innovation from './pages/Innovation';
import Blogs from './pages/Blogs';
import About from './pages/About';
import Contact from './pages/Contact';
import BlogDetail from './pages/BlogDetail';

// Dynamic Pages
import DynamicProduct from './pages/DynamicProduct';
import DynamicService from './pages/DynamicService';
import InnovationDetail from './pages/InnovationDetail';
import Terms from './pages/terms';
import Privacy from './pages/privacy';

import './App.css';




function App() {
  // // 👇 Dynamically detect basename for localhost or production
  //  const basename =
  //    window.location.hostname === "localhost" ? "":"/enessa";
  return (
   <Router>
    <ScrollToTop />
    <ExitIntentPopup />
      <div className="App">
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/services" element={<Services />} />
          <Route path="/products" element={<Products />} />
          <Route path="/innovation" element={<Innovation />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog/:id" element={<BlogDetail />} />

          {/* Dynamic Pages */}
          <Route path="/products/:slug" element={<DynamicProduct />} />
          <Route path="/services/:slug" element={<DynamicService />} />
          <Route path="/innovation/:slug" element={<InnovationDetail />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
